const swiperComparisonTable = new Swiper('.comparison-table__contents', {
  loop: true,
  slidesPerView: 1.5,
  spaceBetween: 16,
  pagination: {
    el: '.table-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next-table',
    prevEl: '.swiper-button-prev-table',
    enabled: true,
  },
  breakpoints: {
    581: {
      slidesPerView: 2.5,
    },
    981: {
      slidesPerView: 4,
    }
  },

  on: {
    init() {
      equalizeComparisonTableRows();
    },
    resize() {
      equalizeComparisonTableRows();
    },
    breakpoint() {
      equalizeComparisonTableRows();
    }
  }
});


function equalizeComparisonTableRows() {
  const columns = document.querySelectorAll(
    '.comparison-table__column-title, .comparison-table__contents .swiper-slide'
  );

  if (!columns.length) return;

  columns.forEach(column => {
    column
      .querySelectorAll('.comparison-table__item-body li')
      .forEach(li => {
        li.style.height = 'auto';
      });
  });

  const rowCount = Math.max(
    ...Array.from(columns).map(column =>
      column.querySelectorAll('.comparison-table__item-body li').length
    )
  );

  for (let row = 0; row < rowCount; row++) {
    let maxHeight = 0;

    columns.forEach(column => {
      const li = column.querySelectorAll(
        '.comparison-table__item-body li'
      )[row];

      if (li) {
        maxHeight = Math.max(
          maxHeight,
          li.getBoundingClientRect().height
        );
      }
    });

    columns.forEach(column => {
      const li = column.querySelectorAll(
        '.comparison-table__item-body li'
      )[row];

      if (li) {
        li.style.height = `${maxHeight}px`;
      }
    });
  }
}

window.addEventListener('load', equalizeComparisonTableRows);
window.addEventListener('resize', equalizeComparisonTableRows);
